export default __webpack_public_path__ + "static/step_3_en-4e89e199df1679490425eba2ec5fa30d.svg";